import { render, staticRenderFns } from "./ResultsPagination.vue?vue&type=template&id=201f2454&"
import script from "./ResultsPagination.vue?vue&type=script&lang=js&"
export * from "./ResultsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports